<template>
  <!-- Carousel wrapper -->
<div
  id="carouselBasicExample"
  class="carousel slide carousel-fade"
  data-mdb-ride="carousel"
>
  <!-- Indicators -->
  <ol class="carousel-indicators">
    <li data-mdb-target="#carouselBasicExample" data-mdb-slide-to="0" class="active"></li>
    <li data-mdb-target="#carouselBasicExample" data-mdb-slide-to="1"></li>
    <li data-mdb-target="#carouselBasicExample" data-mdb-slide-to="2"></li>
    <li data-mdb-target="#carouselBasicExample" data-mdb-slide-to="3"></li>
     <li data-mdb-target="#carouselBasicExample" data-mdb-slide-to="4"></li>
  </ol>

  <!-- Inner -->
  <div class="carousel-inner">
    <!-- Single item -->
    <div class="carousel-item active">
      <img
        src="../assets/FB_IMG_1434717161734.jpg"
        class="d-block w-100"
        alt="..."
      />
  

      <div class="carousel-caption d-none d-md-block">
        <h5>25 År erfarenhet</h5>
        <p>Vi går den andra milen till våra kunder. vår kundtillfredsställelse är vår första prioritet.</p>
      </div>
    </div>
  
   
    

    <div class="carousel-item active">
      <img
        src="../assets/FB_IMG_1434717161734.jpg"
        class="d-block w-100"
        alt="..."
      />
      <div class="carousel-caption d-none d-md-block">
        <h5>25 År erfarenhet</h5>
        <p>Vi går den andra milen till våra kunder. vår kundtillfredsställelse är vår första prioritet.</p>
      </div>
    </div>

    <!-- Single item -->
    <div class="carousel-item">
      <img
        src="../assets/FB_IMG_1434717161734.jpg"
        class="d-block w-100"
        alt="..."
      />
      <div class="carousel-caption d-none d-md-block">
        <h5>25 År erfarenhet</h5>
        <p>Vi går den andra milen till våra kunder. vår kundtillfredsställelse är vår första prioritet.</p>
      </div>
    </div>

    <!-- Single item -->
    <div class="carousel-item">
      <img
        src="../assets/FB_IMG_1434717161734.jpg"
        class="d-block w-100"
        alt="..."
      />
      <div class="carousel-caption d-none d-md-block">
        <h5>25 År erfarenhet</h5>
        <p>Vi går den andra milen till våra kunder. vår kundtillfredsställelse är vår första prioritet.</p>
      </div>
    </div>
  </div>

 

  <!-- Inner -->

  <!-- Controls -->
  <a
    class="carousel-control-prev"
    href="#carouselBasicExample"
    role="button"
    data-mdb-slide="prev"
  >
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </a>
  <a
    class="carousel-control-next"
    href="#carouselBasicExample"
    role="button"
    data-mdb-slide="next"
  >
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </a>
</div>
<!-- Carousel wrapper -->
</template>

<script>
export default {

}
</script>

<style>

</style>